__turbopack_context__.v({
  "fade-in": "SearchSubscription-module-scss-module__hqYlSG__fade-in",
  "item": "SearchSubscription-module-scss-module__hqYlSG__item",
  "list": "SearchSubscription-module-scss-module__hqYlSG__list",
  "no-transform": "SearchSubscription-module-scss-module__hqYlSG__no-transform",
  "rotate": "SearchSubscription-module-scss-module__hqYlSG__rotate",
});
